const MovieCardShimmer = () => {
  return (
    <div className="block w-28 md:w-40 lg:w-48 h-40 md:h-60 lg:h-72 flex-shrink-0 rounded-sm shimmer"></div>
  );
};

export default MovieCardShimmer;
